module.exports = __webpack_public_path__ + "img/main.148a9348.png";